import { render, staticRenderFns } from "./AmbulatoryTables.vue?vue&type=template&id=b6dd1c58&scoped=true&"
import script from "./AmbulatoryTables.vue?vue&type=script&lang=js&"
export * from "./AmbulatoryTables.vue?vue&type=script&lang=js&"
import style0 from "./AmbulatoryTables.vue?vue&type=style&index=0&id=b6dd1c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd1c58",
  null
  
)

export default component.exports